const FlashcardsActionTypes = {
	GET_FLASHCARDS_START: "GET_FLASHCARDS_START",
	GET_FLASHCARDS_SUCCESS: "GET_FLASHCARDS_SUCCESS",
	GET_FLASHCARDS_FAILURE: "GET_FLASHCARDS_FAILURE",
	RESET_FLASHCARDS: "RESET_FLASHCARDS",
};

export default FlashcardsActionTypes;
